<template>
  <q-checkbox
    v-bind="$attrs"
    v-model="value"
    :disable="isDisabled"
    :checked-icon="checkedIcon"
    :unchecked-icon="uncheckedIcon"
    color="primary"
    size="md"
    class="text-sm">
    <!-- Render default slot if provided -->
    <template v-if="$slots.default" #default>
      <slot />
    </template>

    <!-- Else, fallback to label string -->
    <template v-else-if="label" #default>
      {{ label }}
    </template>
  </q-checkbox>
  <div v-if="isPresent(errorMessage)" class="text-xs text-text-danger-tertiary">
    {{ errorMessage }}
  </div>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate';
import { isPresent } from '@/utils/lang';

interface Props {
  initialValue?: boolean;
  name: string;
  label?: string | undefined;
  isDisabled?: boolean;
  checkedIcon?: string;
  uncheckedIcon?: string;
}
const props = withDefaults(defineProps<Props>(), {
  label: '',
  initialValue: false,
  isDisabled: false,
  checkedIcon: 'check_box',
  uncheckedIcon: 'check_box_outline_blank',
});
const { value, errorMessage } = useField(props.name);
value.value = props.initialValue;
</script>
